import { UPDATE_SIGNUP_STATUS } from '../actions/ActionsConstants';

const initialState = {
    signupStatus: ''
};

export default function newsletterSignup(state = initialState, action) {
    switch (action.type) {
        case UPDATE_SIGNUP_STATUS:
            return { ...state, signupStatus: action.value };
        default:
            return state;
    }
}
